import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Store} from "../../../stores/MainStore";
import {TableStore} from "../../../stores/TableStore";
import Utils from "../../../Auth/Utils";
import {API} from "../../../api/API";
import CustomTable from "../../customTables/CustomTable";
import {Dialog, DialogActions, DialogTitle} from "@material-ui/core";
import {StyledButton} from "../../../customstyled/StyledButton";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link} from "react-router-dom";
import {Permission} from "../../../rbac/Permissions";
import {UsersStore} from "../../../stores/UsersStore";

const JobsTable = () => {
    const {dispatch: mainDispatch} = useContext(Store);
    const {state, dispatch} = useContext(TableStore);
    const {state: userState} = useContext(UsersStore);
    const [openForDelete, setOpenForDelete] = useState(false);
    const [jobId, setJobId] = useState('');
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(0);

    const onError = error => {
        mainDispatch({
            type: "SET_MODAL_SETTINGS",
            payload: {
                show: true,
                title: "Error!",
                text: error.message,
                color: "default"
            }
        });
    };

    const deleteOnClicked = (e, id) => {
        e.preventDefault();
        setJobId(id);
        setOpenForDelete(true);
    };

    const handleClose = () => {
        setOpenForDelete(false);
    };

    const deleteJob = async () => {
        const totalAfterDelete = await API.Jobs.JobDelete(jobId);
        setOpenForDelete(false);
        let currentPage = page;
        if (totalAfterDelete.total % size === 0) {
            currentPage = page - 1;
        }
        const table = await API.Jobs.getJobs(currentPage === 0 ? '' : currentPage, size === 0 ? '' : size);
        dispatch({type: "SET_TABLE_INFO", payload: table});
        dispatch({type: "SET_LIST", payload: table.data});
        dispatch({type: "SET_TOTAL_COUNT", payload: table.totalCount});
    };

    // Callbacks function
    const getColumns = () => ([
        {
            name: 'id',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "start", marginLeft: 21}}>#</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-start">
                    <div className="fileName" style={{ marginLeft: 21}}>
                        <span>{rowData.id}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(5)
        },
        {
            name: 'serverName',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Type</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-center">
                    <div>
                        <span>{rowData.jobType}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(13)
        },
        {
            name: 'data',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Data</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-center">
                    <div>
                        <span>{rowData.jobData}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(30)
        },
        {
            name: 'snapshot',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Snapshot</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-left">
                    <div>
                        <span>{rowData.snapshotFileName}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(20)
        },
        {
            name: 'waitTo',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Whait to</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-center">
                    <div>
                        <span>{new Date(rowData.waitDelay).toLocaleString()}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(15)
        },
        {
            name: 'isCanceled',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Is Canceled?</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-center">
                    <div>
                        <span>{rowData.isCanceled ? 'Yes' : 'No'}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(13)
        },
        {
            name: 'lastReason',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Last reason</span>,
            cell: rowData => (
                <div className="d-flex flex-column align-items-left">
                    <div>
                        <span>{rowData.lastReason}</span>
                    </div>
                </div>
            ),
            width: Utils.RemToPx(13)
        },
        {
            name: 'actions',
            header: <span style={{fontSize: "1rem", display: "block", textAlign: "center"}}>Actions</span>,
            cell: rowData => (
                <div className="d-flex justify-content-center align-items-center">
                    {
                        userState.permissions?.includes(Permission.DeleteJobs) ||
                        userState.permissionsAssigned?.includes(Permission.DeleteJobs)
                            ?
                            <StyledButton onClick={e => deleteOnClicked(e, rowData.id)} icon="fas fa-solid fa-trash-can"
                                          tooltip={"Delete job"}
                                          type="danger"
                                          variant="contained"
                                          style={{
                                              padding: 5,
                                              background: '#343a40',
                                              color: '#c2c7d0',
                                              border: 'none',
                                              borderRadius: 3,
                                              cursor: 'pointer',
                                          }}/>
                            : null
                    }
                </div>
            ),
            width: Utils.RemToPx(5)
        }
    ].filter(el => el));

    const getList = useCallback(renderType => {
        return state.list;
    }, [state.list]);

    const getListItems = useCallback(async (renderType, {page, size, text}, onError) => {
        const table = await API.Jobs.getJobs(page, size);
        dispatch({type: "SET_TABLE_INFO", payload: table});
        const total = table.totalCount;
        setPage(page);
        setSize(size);
        dispatch({type: "SET_LIST", payload: table.data});
        dispatch({type: "SET_TOTAL_COUNT", payload: table.totalCount});

        return total ?? 0;
    }, []);

    const setRenderType = renderType => dispatch({type: "SET_RENDER_TYPE", payload: renderType});
    const clearLists = () => dispatch({type: "SET_LIST", payload: []});

    useEffect(() => {
        return () => {
            clearLists();
            dispatch({type: "SET_LIST", payload: 0});
            setRenderType("basic");
        };
    }, []);

    return (
        <>
            <div className="snapShotsTable">
                <div style={{float: 'none'}}>
                    <div className="routeContainer">
                        <Breadcrumbs aria-label="breadcrumb" className="currentSnapshotInfo">
                            <Link to="/" className="black routes">
                                <span>Dashboard</span>
                            </Link>
                            <span className="route">Jobs</span>
                        </Breadcrumbs>
                    </div>
                </div>
                <h3 className="tableTitle marginZero">ACP : Jobs</h3>
                <section className="content">
                    <div id="table-container">
                        <CustomTable state={{
                            typeOfRender: state.renderType,
                            canSelect: false,
                            canHover: false,
                            canSearch: false,
                            pagination: true
                        }} callbacks={{getList, getColumns, getListItems, setRenderType, clearLists, onError}}
                                     texts={{noItems: "No jobs"}}/>
                    </div>
                </section>
            </div>
            <Dialog open={openForDelete} onClose={handleClose}>
                <DialogTitle>
                    Are you sure you want to cancel the job in queue?
                </DialogTitle>
                <DialogActions>
                    <StyledButton onClick={deleteJob} title="Confirm" type="danger"
                                  variant="contained" style={{
                        padding: 5,
                        background: '#343a40',
                        color: '#c2c7d0',
                        border: 'none',
                        borderRadius: 3,
                        cursor: 'pointer',
                    }}/>
                    <StyledButton onClick={() => setOpenForDelete(false)} autoFocus
                                  disabled={false} title="Cancel"
                                  type="success" variant="contained" style={{
                        padding: 5,
                        background: '#343a40',
                        color: '#c2c7d0',
                        border: 'none',
                        borderRadius: 3,
                        cursor: 'pointer',
                    }}/>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default JobsTable;